/**
 * Created by satans17 on 2016/12/11.
 */
import $ from '@ali/tarzan-zepto';
import util from '../../lib/util';

const pluginStorage = [];
const regVersion = /^(\d{1,2})\.(\d{1,2})\.(\d{1,2})$/;
const regURL = /\S+/;

export default Object.create({
  /**
   * 添加插件
   * @param key
   * @param plugin
   */
  add(key, plugin) {
    let k = key;
    let p = plugin;
    let loaded = 1;

    if (util.isFunction(key)) {
      k = null;
      p = key;
    }

    // 不允许命名为 null 的异步插件
    if (k === null && util.isString(p)) {
      return;
    }

    // 校验 key 是否存在
    const isExistKey = pluginStorage.filter((item) => {
      const r = item.key === key;
      return r;
    });
    if (isExistKey.length) {
      isExistKey.forEach((t) => {
        // 有重复的插件，后面的替换前面的
        for (let z = 0; z < pluginStorage.length; z += 1) {
          if (pluginStorage[z].key === t.key) {
            pluginStorage[z] = {
              key: k,
              fn: p,
              loaded: 1,
            };
          }
        }
      });
      // 存在同名的插件，不注册
      return;
    }

    // 异步插件
    // 版本号: 0.1.12
    // 或者 CDN 地址: //g.alicdn.com/alicare/alicare-plugin-test/0.1.2/index.js
    if (typeof p === 'string' && (regVersion.test(p) || regURL.test(p))) {
      loaded = 0;
    }

    pluginStorage.push({
      key: k,
      fn: p,
      loaded,
    });
  },

  /**
   * 获取对应KEY的所有插件
   */
  getPlugins(key) {
    return new Promise((resolve, reject) => {
      const plugins = pluginStorage;
      const result = [];

      for (let i = 0; i < plugins.length; i += 1) {
        if (plugins[i].key === key || plugins[i].key === null) {
          // 保证插件执行的顺序和注册的顺序一致
          result.push(plugins[i]);
        }
      }

      // 如果没有找到对应 key 的插件，则返回错误
      const checkStatus = result.filter((item) => {
        const r = item.key !== null;
        return r;
      });
      if (!checkStatus.length) {
        reject(`插件[${key}]未注册`);
      }

      // 检查是否有异步插件
      const hasAsyncPlugin = result.filter((item) => {
        const r = !item.loaded;
        return r;
      });
      if (!hasAsyncPlugin.length) {
        resolve(result);
      } else {
        this.getAsyncPlugins(result).then((ps) => {
          resolve(ps);
        }, () => {
          reject('插件获取异常');
        });
      }
    });
  },

  /**
   * 获取异步插件，并更新插件状态
   */
  getAsyncPlugins(ds) {
    const result = ds;

    return new Promise((resolve, reject) => {
      const async = [];
      for (let i = 0; i < ds.length; i += 1) {
        if (!ds[i].loaded) {
          async.push(this.getAsyncPlugin(ds[i]));
        }
      }
      // 获取所有异步插件
      // 在 getAsyncPlugin() 方法中 hack 所有插件都加载成功
      Promise.all(async).then((rs) => {
        for (let x = 0; x < rs.length; x += 1) {
          // 更新 ds
          for (let y = 0; y < ds.length; y += 1) {
            if (result[y].key === rs[x].key) {
              result[y].fn = rs[x].fn;
            }
          }

          // 更新 pluginStorage
          for (let z = 0; z < pluginStorage.length; z += 1) {
            if (pluginStorage[z].key === rs[x].key) {
              pluginStorage[z] = {
                key: rs[x].key,
                fn: rs[x].fn,
                loaded: 1,
              };
            }
          }
        }
        resolve(result);
      }, () => {
        reject('获取插件异常');
      });
    });
  },

  /**
   * 获取单个异步插件
   */
  getAsyncPlugin(d) {
    return new Promise((resolve) => {
      const fn = d.fn;
      const key = d.key;
      const errReturn = {
        key,
        fn: null,
        loaded: 1,
      };
      let assetsCDN = null;
      const host = util.getEnvironment() === 'prod' ? '//g.alicdn.com' : '//g-assets.daily.taobao.net';
      if (regVersion.test(fn)) {
        assetsCDN = `${host}/alicare/alicare-plugin-${key}/${fn}/index-min.js`;
      } else if (regURL.test(fn)) {
        assetsCDN = fn;
      }

      if (!assetsCDN) {
        resolve(errReturn);
      }

      $.ajax({
        type: 'get',
        url: assetsCDN,
        dataType: 'jsonp',
        jsonp: 'callback',
        jsonpCallback: `AlicarePlugin${key.replace(/^\w/, n => n.toUpperCase())}`,
        timeout: 10000,
        success: (p) => {
          const mod = p() || {};
          if (typeof mod === 'function' || typeof mod.default === 'function') {
            resolve({
              key,
              fn: mod.default || mod,
              loaded: 1,
            });
          } else {
            resolve(errReturn);
            // @TODO 记录日志
          }
        },
        error: () => {
          resolve(errReturn);
          // @TODO 记录日志
        },
      });
    });
  },
});



// WEBPACK FOOTER //
// ./src/component/pipeline/plugin.js